import { Injectable, inject } from '@angular/core';

import { FsTransferService } from '@firestitch/transfer';
import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FieldData {
  private _fsApi = inject(FsApi);
  private _transfer = inject(FsTransferService);


  public create(data = { id: null }) {
    return data;
  }

  public saveFields(objectId: number, data: {}): Observable<any> {
    return this._fsApi.put(`fields/${objectId}`, data, { key: 'fields' });
  }

  public getFields(objectId: number): Observable<any> {
    return this._fsApi.get(`fields/${objectId}`, null, { key: 'fields' });
  }

  public saveValues(configObjectID: number, valueObjectID: number, objectVersionId: number, fields = []): Observable<any> {
    return this._fsApi.post(`fields/${configObjectID}/values/${valueObjectID}/${objectVersionId}`, { fields }, { key: 'data' });
  }

  public imagesPost(
    configObjectId: number,
    dataObjectId: number,
    fieldGuid: string,
    objectVersionId: number,
    data: any = {},
    config: RequestConfig = {}): Observable<any> {
    data.objectVersionId = objectVersionId;
    const requestConfig = { key: '', ...config };

    return this._fsApi.post(`fields/${configObjectId}/images/${dataObjectId}/${fieldGuid}`, data, requestConfig);
  }

  public filesPost(
    configObjectId: number,
    dataObjectId: number,
    fieldGuid: string,
    objectVersionId: number,
    data: any = {},
    config: RequestConfig = {}): Observable<any> {
    data.objectVersionId = objectVersionId;
    const requestConfig = { key: '', ...config };

    return this._fsApi.post(`fields/${configObjectId}/files/${dataObjectId}/${fieldGuid}`, data, requestConfig);
  }

  public filesDelete(
    configObjectId: number,
    dataObjectId: number,
    fieldGuid: string,
    objectVersionId,
    data: any = {},
  ): Observable<any> {
    data.object_version_id = objectVersionId;

    return this._fsApi.delete(`fields/${configObjectId}/files/${dataObjectId}/${fieldGuid}`, data, { key: '' });
  }

  public download(
    configObjectId: number,
    dataObjectId: number,
    fieldGuid: string,
    data: any = {},
  ): void {
    this._transfer.post(`fields/${configObjectId}/files/${dataObjectId}/${fieldGuid}/download`, data);
  }

  public getValues(
    configObjectID: number,
    valueObjectID: number,
    versionId: number,
    data: any = {},
    config = { key: 'fields' },
  ): Observable<any> {
    return this._fsApi.get(`fields/${configObjectID}/values/${valueObjectID}${versionId ? `/${versionId}` : ''}`, data, config);
  }
}
